import { createHistory } from 'history';
export default createHistory();